export default __webpack_public_path__ + "static/1858-2407639c9dd491d8b60315d8762cad8e.gif";